import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  useMediaQuery,
  createTheme,
  Box
} from "@mui/material";
import { FacturaInforme, cuentaComoFactura } from "../Informes";
import { formatCurrency } from "../../../../utils/Factura";

interface TablaPorPacienteProps {
  facturas: FacturaInforme[];
  type: "gasto" | "deuda";
}

const TablaPorPaciente = ({ facturas, type }: TablaPorPacienteProps) => {
  const theme = createTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const facturasFiltradas = type === "deuda"
    ? facturas.filter(f => f.estadoPago === "Pendiente")
    : facturas.filter(f => f.estadoPago === "Pagada");
  const moneda = facturas[0]?.moneda || 'EUR';

  const data = Object.values(
    facturasFiltradas.reduce((acc, f) => {
      if (!acc[f.paciente]) {
        acc[f.paciente] = { pacienteId: f.paciente, numFacturas: 0, total: 0 };
      }
      if (cuentaComoFactura(f)) acc[f.paciente].numFacturas += 1;
      acc[f.paciente].total += f.total;
      return acc;
    }, {} as Record<string, { pacienteId: string; numFacturas: number; total: number }>)
  );

  data.sort((a, b) => b.total - a.total);
  if (data.length === 0) return null;
  const dataFinal = type === "gasto" ? data.slice(0, 10) : data;
  return (
    <Card >
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {type === "deuda" ? "Pacientes con facturas pendientes" : "Top 10 pacientes con mayor gasto"}
        </Typography>
        {isMobile ?
        <Box>
          {dataFinal.map((row) => (
            <Paper
              key={row.pacienteId}
              sx={{ p: 2, mb: 2, borderRadius: 2 }}
            >
              {/* FILA 1: paciente */}
              <Typography variant="body1" fontWeight={500}>
                {row.pacienteId}
              </Typography>

              {/* FILA 2: nº facturas + total */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={1}
              >
                <Typography variant="body2" color="text.secondary">
                  {row.numFacturas} facturas
                </Typography>

                <Typography
                  variant="h6"
                  fontWeight={600}
                  color={type === "deuda" ? "error.main" : "text.primary"}
                >
                  {formatCurrency(row.total, moneda)}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Box> :
        <TableContainer component={Paper} sx={{ boxShadow: 'none', maxHeight: 400 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: 'grey.100' }}>
                <TableCell>Paciente</TableCell>
                <TableCell align="right">Número de facturas</TableCell>
                <TableCell align="right">{type === "deuda" ? "Total adeuado" : "Total pendiente"}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataFinal.map(row => (
                <TableRow key={row.pacienteId} hover>
                  <TableCell>{row.pacienteId}</TableCell>
                  <TableCell align="right">{row.numFacturas}</TableCell>
                  <TableCell
                    align="right"
                    sx={type === "deuda" ? { color: "error.main", fontWeight: 600 } : {fontWeight: 600}}
                  >
                    {formatCurrency(row.total, moneda)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>}
      </CardContent>
    </Card>
  );
};

export default TablaPorPaciente;
